import { render, staticRenderFns } from "./DashboardDigestFormDialog.vue?vue&type=template&id=67f97c0e"
import script from "./DashboardDigestFormDialog.vue?vue&type=script&lang=js"
export * from "./DashboardDigestFormDialog.vue?vue&type=script&lang=js"
import style0 from "./DashboardDigestFormDialog.vue?vue&type=style&index=0&id=67f97c0e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports